module.exports = __webpack_public_path__ + "img/rg_object_history_menu_hover.44e5af88.svg";